import { render, staticRenderFns } from "./editable-label.component.vue?vue&type=template&id=5a19e635&scoped=true"
import script from "./editable-label.component.vue?vue&type=script&lang=ts"
export * from "./editable-label.component.vue?vue&type=script&lang=ts"
import style0 from "./editable-label.component.vue?vue&type=style&index=0&id=5a19e635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19e635",
  null
  
)

export default component.exports